import _ from 'lodash';
import jsonLogic from 'json-logic-js';

class Maestro {
  // general app-wide reusable roolz
  baseRoolz(state) {
    const data = {
      flow: _.get(state, 'common.flow'),
      consumerType: _.get(state, 'common.consumerType', '')
    };

    const logic = {
      isMoversFlow: {"==": [{"var":"flow"}, "movers"] },
      isOmni: {
        "if": {
          "or": [
            {"==": [{"var":"consumerType"}, "Einstein360"] },
            {"==": [{"var":"consumerType"}, "Etail"] }
          ]
        }
      },
      disableExternalLinks: {
        "if": {
          "or": [
            {"==": [{"var":"consumerType"}, "Einstein360"] },
            {"==": [{"var":"consumerType"}, "Etail"] }
          ]
        }
      }
    };

    return {data, logic};
  }

  conduct(state, data = {}, logic = {}) {
    const baseRoolz = this.baseRoolz(state);
    const mergedLogic = Object.assign({}, baseRoolz.logic, logic);
    const mergedData = Object.assign({}, baseRoolz.data, data);
    const keys = Object.keys(mergedLogic);

    return keys.reduce((p, key) => {
      return Object.assign({}, p, {[key]: jsonLogic.apply(mergedLogic[key], mergedData)});
    }, {});
  }
}

//Ensure only a singleton is exported
const instance = new Maestro();

export default instance;



/** WEBPACK FOOTER **
 ** ./client/util/maestro/maestro.js
 **/